// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d5447ef3","89":"d9655c91","184":"d17884cc","513":"0ce836dc","669":"a640df0b","703":"72bb62ca","925":"28f1887c"}[chunkId] + ".chunk.js";
};